import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';

import styled from 'styled-components';
import { withModalTitle } from '../../../hooks/modal/withModalTitle.tsx';
import { DeviceActivityRoute } from './DeviceActivityRoute.tsx';
import DeviceCallLogRoute from './DeviceCallLogRoute.jsx';
import { DeviceOverview } from './DeviceOverview.tsx';
import { DevicesList } from './DevicesList.tsx';
import { EditBatteryModeRoute } from './EditBatteryModeRoute.tsx';
import { EditDeviceName } from './EditDeviceName.tsx';
import { EditMapMarkerIcon } from './EditMapMarkerIcon.tsx';
import { EditSpeedAlertRoute } from './EditSpeedAlertRoute.tsx';
import PurchaseAudioMinutesRoute from './PurchaseAudioMinutesRoute.jsx';
import { DeviceServicePlanRoute } from './DeviceServicePlanRoute.tsx';
import { DeviceServicePlanCancelRoute } from './DeviceServicePlanCancelRoute.tsx';
import { DeviceDataExportsRoute } from './DeviceDataExportsRoute.tsx';
import { CreateDeviceDataExportRoute } from './CreateDeviceDataExportRoute.tsx';

const DevicesRouteContainer = styled.div`
  margin-bottom: 35px;
`;

interface DevicesRouteProps {};
export const DevicesRoute: React.FC<DevicesRouteProps> = () => {

  let { path } = useRouteMatch();

  return (
    <DevicesRouteContainer>
        <Route
         exact
         path={path}
         component={DevicesList}
        />
        <Route exact path={`${path}/:id`} component={DeviceOverview} />
        <Route exact path={`${path}/:id/name`} component={EditDeviceName} />
        <Route exact path={`${path}/:id/map-icon`} component={EditMapMarkerIcon} />
        <Route exact path={`${path}/:id/call-log`} component={withModalTitle(DeviceCallLogRoute, 'Audio Log')} />
        <Route exact path={`${path}/:id/purchase-audio-minutes`} component={withModalTitle(PurchaseAudioMinutesRoute, 'Purchase Audio Minutes')} />
        <Route exact path={`${path}/:id/edit-speed-alert`} component={EditSpeedAlertRoute} />
        <Route exact path={`${path}/:id/activity`} component={DeviceActivityRoute} />
        <Route exact path={`${path}/:id/edit-battery-mode`} component={EditBatteryModeRoute} />
        <Route exact path={`${path}/:id/plan`} component={DeviceServicePlanRoute} />
        <Route exact path={`${path}/:id/plan/cancel`} component={DeviceServicePlanCancelRoute} />
        <Route exact path={`${path}/:id/data-exports`} component={DeviceDataExportsRoute} />
        <Route exact path={`${path}/:id/data-exports/new`} component={CreateDeviceDataExportRoute} />

    </DevicesRouteContainer>
  )
};
